import React, { useState } from "react";
import TextInput from "../fields/TextInput";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import { useSelector } from "react-redux";

const UploadDocumentPage = ({
  errmsg,
  handleBooking,
  uploadDoc,
  onChange,
  setErrMsg,
}) => {
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const [image, setImage] = useState(null);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const documentsData = useSelector((state) => state.booking.documentsData);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  return (
    <div className="card radio-shadow h-100">
      <h3 className="booking-label border-0 card-header font">
        Upload Document
      </h3>
      <div className="card-body mt-4 ">
        <div className="row">
          {/* <div className='col-6' >
                        <div className='mb-3' >
                            <p className='input-label my-2' >Identity Card (Front):</p>
                            <div className="file-input ">
                                <label
                                    className={`w-100 ${errmsg?.IDfront ? "error rounded-2" : null}`}
                                    htmlFor="IDfront">
                                    <input
                                        type="file"
                                        name="IDfront"
                                        id="IDfront"
                                        className="file-input__input"
                                        onChange={onChange}
                                    />


                                    {userDetail?.data?.identityFront ? (
                                        <img className='upload-doc mx-auto pointor' src={`${baseURL}${userDetail?.data?.identityFront}`} />
                                    ) : uploadDoc?.IDfront ? (
                                        <img className='upload-doc mx-auto pointor' src={uploadDoc?.IDfront} />
                                    ) : (
                                        <div className='file-input__label' >
                                            <span className="text-truncate" ><MdOutlineFileUpload className='upload-icon me-2' />Upload</span>
                                        </div>
                                    )}
                                </label>
                            </div>
                            <p className='location-err' >{errmsg.IDfront}</p>
                        </div>

                        <div className='mb-3' >
                            <p className='input-label my-2' >Licence (Front):</p>
                            <div className="file-input">
                                <label
                                    className={` w-100 ${errmsg?.licenceFront ? "error rounded-2" : null}`}

                                    htmlFor="licenceFront">
                                    <input
                                        type="file"
                                        name="licenceFront"
                                        id="licenceFront"
                                        className="file-input__input"
                                        onChange={onChange}
                                    />
                                    {userDetail?.data?.drivingLicenseFront ? (
                                        <img className='upload-doc mx-auto pointor' src={`${baseURL}${userDetail?.data?.drivingLicenseFront}`} />
                                    ) : uploadDoc?.IDfront ? (
                                        <img className='upload-doc mx-auto pointor' src={uploadDoc?.licenceFront} />
                                    ) : (
                                        <div className='file-input__label' >
                                            <span className="text-truncate" ><MdOutlineFileUpload className='upload-icon me-2' />Upload</span>
                                        </div>
                                    )}


                                </label>
                            </div>
                            <p className='location-err' >{errmsg.licenceFront}</p>
                        </div>

                    </div> */}
          {/* <div className="col-6"> */}
          <div className="col-8">
            <div className="mb-3">
              <p className="input-label my-2">
                Identity Card (Front):<span style={{ color: "red" }}>*</span>
              </p>
              <div className="file-input ">
                <label
                  className={`w-100 ${
                    errmsg?.IDfront ? "error rounded-2" : null
                  }`}
                  htmlFor="IDfront"
                >
                  <input
                    type="file"
                    name="IDfront"
                    id="IDfront"
                    className="file-input__input"
                    accept="image/*"
                    onChange={onChange}
                  />
                  {/* {uploadDoc?.IDfront ? (
                    <>
                      {uploadDoc?.IDfront ===
                      userDetail?.data?.identityFront ? (
                        <>
                          <img
                            className="upload-doc mx-auto pointor"
                            src={`${baseURL}${userDetail?.data?.identityFront}`}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            className="upload-doc mx-auto pointor"
                            src={uploadDoc?.IDfront}
                          />
                        </>
                      )}
                    </>
                  ) : userDetail?.data?.identityFront ? (
                    <img
                      className="upload-doc mx-auto pointor"
                      src={`${baseURL}${userDetail?.data?.identityFront}`}
                    />
                  ) : (
                    <div className="file-input__label">
                      <span className="text-truncate">
                        <MdOutlineFileUpload className="upload-icon me-2" />
                        Upload
                      </span>
                    </div>
                  )} */}
                  {uploadDoc?.IDfront ? (
                    <img
                      className="upload-doc mx-auto pointor"
                      src={baseURL+uploadDoc?.IDfront}
                    />
                  ) : (
                    <div className="file-input__label">
                      <span className="text-truncate">
                        <MdOutlineFileUpload className="upload-icon me-2" />
                        Upload
                      </span>
                    </div>
                  )}
                </label>
              </div>
              <p className="location-err">{errmsg.IDfront}</p>
            </div>
            {/* {!withDriver ? ( */}
            <div className="mb-3">
              <p className="input-label my-2">
                {/* Licence (Front):<span style={{ color: "red" }}>*</span> */}
                Identity Card (Back side):
                <span style={{ color: "red" }}>*</span>
              </p>
              <div className="file-input">
                <label
                  className={` w-100 ${
                    errmsg?.licenceFront ? "error rounded-2" : null
                  }`}
                  htmlFor="licenceFront"
                >
                  <input
                    type="file"
                    accept="image/*"
                    name="licenceFront"
                    id="licenceFront"
                    className="file-input__input"
                    onChange={onChange}
                  />

                  {uploadDoc?.licenceFront ? (
                    <img
                      className="upload-doc mx-auto pointor"
                      src={baseURL+uploadDoc?.licenceFront}
                    />
                  ) : (
                    <div className="file-input__label">
                      <span className="text-truncate">
                        <MdOutlineFileUpload className="upload-icon me-2" />
                        Upload
                      </span>
                    </div>
                  )}
                </label>
              </div>
              <p className="location-err">{errmsg.licenceFront}</p>
            </div>
            {/* ) : null} */}
          </div>
          {/* <div className='mb-3' >
                        {
                            uploadDoc?.IDfront ? (
                                <>
                                    <img className='upload-doc mx-auto pointor' src={uploadDoc?.licenceFront} />

                                </>) : (
                                <>
                                    <img className='upload-doc mx-auto pointor' src={`${baseURL}${userDetail?.data?.drivingLicenseFront}`} />
                                </>
                            )
                        }

                    </div> */}

          {/* <div className='col-6' >



                        <div className='mb-3' >
                            <p className='input-label my-2' >Identity Card (Back):</p>
                            <div className="file-input">
                                <label
                                    className={` w-100 ${errmsg?.IDbackErrMsg ? "error rounded-2" : null}`}

                                    htmlFor="IDback">
                                    <input
                                        type="file"
                                        name="IDback"
                                        id="IDback"
                                        className="file-input__input"
                                        onChange={onChange}
                                    />

                                    {userDetail?.data?.identityBack ? (
                                        <img className='upload-doc mx-auto pointor' src={`${baseURL}${userDetail?.data?.identityBack}`} />
                                    ) : uploadDoc?.IDback ? (
                                        <img className='upload-doc mx-auto pointor' src={uploadDoc?.IDback} />
                                    ) : (
                                        <div className='file-input__label' >
                                            <span className="text-truncate" ><MdOutlineFileUpload className='upload-icon me-2' />Upload</span>
                                        </div>
                                    )}


                                </label>
                            </div>
                            <p className='location-err' >{errmsg.IDbackErrMsg}</p>
                        </div>

                        <div className='mb-3' >
                            <p className='input-label my-2' >Licence (Back):</p>
                            <div className="file-input">
                                <label
                                    className={`w-100 ${errmsg?.licencebackErrMsg ? "error rounded-2" : null}`}

                                    htmlFor="licenceBack">
                                    <input
                                        type="file"
                                        name="licenceBack"
                                        id="licenceBack"
                                        className="file-input__input"
                                        onChange={onChange}
                                    />

                                    {userDetail?.data?.drivingLicenseBack ? (
                                        <img className='upload-doc mx-auto pointor' src={`${baseURL}${userDetail?.data?.drivingLicenseBack}`} />
                                    ) : uploadDoc?.licenceBack ? (
                                        <img className='upload-doc mx-auto pointor' src={uploadDoc?.licenceBack} />
                                    ) : (
                                        <div className='file-input__label' >
                                            <span className="text-truncate" ><MdOutlineFileUpload className='upload-icon me-2' />Upload</span>
                                        </div>
                                    )}

                                </label>
                            </div>
                            <p className='location-err' >{errmsg.licencebackErrMsg}</p>
                        </div>
                    </div> */}
        </div>
      </div>
      <div className="card-footer border-0 bg-transparent">
        <button
          type="button"
          onClick={handleBooking}
          className="btn mt-sm-3 w-100 img-btn primaryColor"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default UploadDocumentPage;
